var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg21OverIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16.3 16.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1d3152;}.cls-2,.cls-3{font-size:9.26px;fill:#fff;font-family:Montserrat-Bold, Montserrat;font-weight:700;}.cls-3{letter-spacing:-0.08em;}.cls-4{letter-spacing:0em;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 8.15,
    cy: 8.15,
    r: 8.15
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(2.05 11.07)"
  }, "2"), /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(7.07 11.07)"
  }, "1", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-4",
    x: 2.88,
    y: 0
  }, "+"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg21OverIcon);
export default __webpack_public_path__ + "static/media/21OverIcon.d88ab55c9a2d5aa5139befd3538b9dac.svg";
export { ForwardRef as ReactComponent };